import axios from 'axios';
import { TSPBody } from 'bindings/optimization/TSPBody';
import { URL_FOUNDATION } from '../../../config/keys';

export async function sequenceEvents(body: { waypoints: unknown[]; mode: string }) {
	return await axios.post(`${URL_FOUNDATION}/api/map/sequence`, body);
}

interface BulkCreateEventBody {
	events: Array<{
		title: string;
		start: number;
		end: number;
		company_id?: number;
		description?: string;
	}>;
	linked_form?: number;
	type_id: number;
	owner_id: number;
}

export async function bulkCreateEvents(body: BulkCreateEventBody) {
	return await axios.post(
		`${URL_FOUNDATION}/api/v2/client-companies/bulk-create/events`,
		body
	);
}

type TSPNode = {
	node: number;
	lat: number;
	lon: number;
};

type TSPPoint = Exclude<TSPNode, 'node'> & {
	id: number;
	priority: number;
};

type TSPDroppedNode = TSPNode & {
	priority: number;
};

type TSPDayTravel = {
	day: number;
	/// Backend label ("Monday", "Day 3", …) — prefer deriving a localised
	/// date client-side; the backend names are not localised.
	label: string;
	visits: number;
	travel_secs: number;
	travel_km: number;
};

type TSPWeekTravel = {
	week: number;
	visits: number;
	travel_secs: number;
	travel_km: number;
};

type TSPTravelTotal = {
	visits: number;
	travel_secs: number;
	travel_km: number;
};

type TSPRoute = {
	days: string;
	end_day: number;
	start_day: number;
	vehicle: number;
	geometry: [number, number][];
	stops: (TSPNode & { day: number; arrival: string; departure: string })[];
	day_travel?: TSPDayTravel[];
};

export type TSPResponse = {
	dropped_nodes: TSPDroppedNode[];
	points: TSPPoint[];
	routes: TSPRoute[];
	// Optional: absent on backends older than the vrp branch.
	day_summaries?: TSPDayTravel[];
	week_summaries?: TSPWeekTravel[];
	total?: TSPTravelTotal;
};

export async function sequenceEventsTSP(body: TSPBody): Promise<TSPResponse> {
	return await axios
		.post<TSPResponse>(`${URL_FOUNDATION}/api/v2/optimization/tsp`, body)
		.then(res => {
			return res.data;
		});
}
